/* import __COLOCATED_TEMPLATE__ from './icon-info-circle.hbs'; */
import SvgIcon from './svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--info-circle'],
  width: 18,
  height: 18,
  viewBox: '0 0 16 16'
});